var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "41px",
    viewBox: "0 0 37 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-navigation-bar",
    transform: "translate(-20.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4101312,21.7844637 L14.0828692,18.5387881 C13.6266592,18.0961572 12.9617186,17.9232902 12.3385242,18.0853044 C11.7153297,18.2473185 11.2285594,18.7196 11.061575,19.324245 C10.8945905,19.92889 11.0727608,20.5740386 11.5289708,21.0166695 L16.133182,25.4838358 C16.470884,25.8141839 16.9305783,26 17.4101312,26 C17.8896841,26 18.3493784,25.8141839 18.6870804,25.4838358 L28.4710292,15.9911073 C28.9272392,15.5484764 29.1054095,14.9033279 28.938425,14.2986829 C28.7714406,13.6940378 28.2846703,13.2217563 27.6614758,13.0597422 C27.0382814,12.897728 26.3733408,13.0705951 25.9171308,13.513226 L17.4101312,21.7844637 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8323277,1.73756365 L34.0040874,8.19930754 C35.8581901,9.27172021 37,11.2511909 37,13.3930979 L37,26.3354734 C37,28.4773804 35.8581901,30.4568511 34.0040874,31.5292638 L22.8323277,37.9910077 C20.9738448,39.0659538 18.6826356,39.0659538 16.8241528,37.9910077 L5.65239303,31.5292638 C3.79829034,30.4568511 2.65648048,28.4773804 2.65648048,26.3354734 L2.65648048,13.3930979 C2.65648048,11.2511909 3.79829034,9.27172021 5.65239303,8.19930754 L16.8241528,1.73756365 C18.6826356,0.662617504 20.9738448,0.662617504 22.8323277,1.73756365 Z",
    id: "Polygon",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.720a918d9069f704c725cbb2c88ea8b4.svg";
export { ForwardRef as ReactComponent };